import { z } from "zod/v4";

import { PendingPluginPerformanceTestSchema } from "../../../schemas/plugin";

export const RequestPluginPerformanceRequestBodySchema = z.object({
  themeId: z.string().nullish(),
});

export type RequestPluginPerformanceRequestBodyType = z.infer<
  typeof RequestPluginPerformanceRequestBodySchema
>;

export const RequestPluginPerformanceResponseBodySchema = z.object({
  tests: PendingPluginPerformanceTestSchema.array(),
});

export type RequestPluginPerformanceResponseBodyType = z.infer<
  typeof RequestPluginPerformanceResponseBodySchema
>;
